// extracted by mini-css-extract-plugin
export default {"titleContainer":"Post_titleContainer__2Zolj","chevronIcon":"Post_chevronIcon__qqbrd","content":"Post_content__1jRpv"};